import { render, staticRenderFns } from "./dateDisplay.vue?vue&type=template&id=3705a760"
import script from "./dateDisplay.vue?vue&type=script&lang=js"
export * from "./dateDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports